<template lang="pug">
    media-list-control(v-bind="$attrs" :media="media")
</template>

<script>
import MediaFeedService from '../../services/media-feed-service'

export default {
    name: 'media-feed-control',

    props: {
        focusUserId: {
            type: String,
        },
        mediaType: {
            type: String,
        },
        maxItems: {
            type: Number,
        },
    },

    data() {
        return {
            media: [],
        }
    },

    watch: {
        focusUserId() {
            this.load()
        },
    },

    methods: {
        load() {
            MediaFeedService.list({
                userId: this.focusUserId,
                mediaType: this.mediaType,
                page_size: this.maxItems,
            }).then(({data}) => {
                const media = data.data
                this.media = this.maxItems ? media.slice(0, this.maxItems) : media

                this.$emit('load', {
                    count: this.media.length,
                })
            })
        },
    },

    created() {
        this.load()
    },
}
</script>
